import { Component, OnInit } from '@angular/core';

import { tipoAjustesModuleName } from "../shared/data.service";
import { UtilService } from "../../../shared/services/util.service";
import { AbastecimentoService } from "../../shared/abastecimento.service";
import { TipoAjuste } from "../shared/tipo-ajuste.model";
import { TipoAjusteApiService } from "../shared/tipo-ajuste-api.service";
import { TipoAjusteService } from "../shared/tipo-ajuste.service";
import { TipoAjusteNavigationService } from "../shared/tipo-ajuste-navigation.service";
import {abastecimentosModuleName} from "../../shared/data.service";
import {configuracaoModuleName} from "../../../shared/services/data.service";

@Component({
    template: require('./tipo-ajuste-list.component.html'),
    styles: [require('./tipo-ajuste-list.component.css')]
})
export class TipoAjusteListComponent implements OnInit {
    list: TipoAjuste[] = [];
    loading: boolean = true;
    showDisabled: boolean = false;
    tipoAjustesModuleName: any = tipoAjustesModuleName;
    module: any = abastecimentosModuleName;
    configuracaoModule: any = configuracaoModuleName;

    constructor(
        private _tipoAjustesApiService: TipoAjusteApiService,
        private _tipoAjusteService: TipoAjusteService,
        private _tipoAjusteNavigationService: TipoAjusteNavigationService,
        private _utilService: UtilService,
        private _abastecimentoService: AbastecimentoService
    ) { }

    ngOnInit() {
        this.getAll();
    }

    clickNew() {
        this._tipoAjusteService.clearSessionStorage();
        this._tipoAjusteNavigationService.goToNew();
    }

    clickGoToSettings() {
        this._abastecimentoService.goToSetting();
    }

    clickEdit(item: TipoAjuste) {
        this._tipoAjusteService.clearSessionStorage();
        this._tipoAjusteNavigationService.goToEdit(item.id);
    }

    clickDelete(item: TipoAjuste) {
        var onDelete = (function() {
            this.onDelete(item);
        }.bind(this));

        this._utilService.swalMessageDelete(onDelete);
    }

    private getAll() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.list = Response;
            }
            this.loading = false;
        }.bind(this));

        this._tipoAjustesApiService.onGetAll(onDone);
    }

    private onDelete(item: any) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                var x: number, lenX: number;
                for (x = 0, lenX = this.list.length; x < lenX; x++) {
                    if (this.list[x].id === item.id) {
                        this.list[x].ativo = false;
                        break;
                    }
                }
                this._utilService.swalMessageDeleteSuccess();
            } else {
                this._utilService.swalMessageDeleteError();
            }
        }.bind(this));

        this._tipoAjustesApiService.onDelete(item.id, onDone);
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/tipo-ajustes/tipo-ajuste-list/tipo-ajuste-list.component.ts
 **/